import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'onefaceui-react-components';

import StatusCaption from 'react/components/StatusCaption';
import { getResourceTo } from 'react/utils/utils';

function EquipmentStatusCaption({ equipmentList }) {
  const toggleLabel = getResourceTo(
    'permission.tracker.equipment_route_status'
  );

  const options = [
    ...equipmentList.map((equipment) => ({
      type: equipment?.type || equipment.key,
      title: equipment.key?.toUpperCase(),
      captionItemLabelStyle: {
        width: '8px',
        height: '8px',
        backgroundColor: equipment.coordinatesColor || '#FF41A6'
      }
    })),
    {
      type: 'moving',
      title: getResourceTo('maps.legend.truckOnAndMoving'),
      captionItemLabelClassname: 'green-label'
    },
    {
      type: 'stopped',
      title: getResourceTo('maps.legend.truckOnAndStopped'),
      captionItemLabelClassname: 'purple-label'
    },
    {
      type: 'turnedOff',
      title: getResourceTo('maps.legend.truckOff'),
      captionItemLabelClassname: 'black-label'
    }
  ];

  return (
    <Flex className="caption-info equipment-stop" alignItems="center" gap={16}>
      <StatusCaption toggleLabel={toggleLabel} options={options} />
    </Flex>
  );
}

EquipmentStatusCaption.propTypes = {
  equipmentList: PropTypes.array.isRequired
};

export default memo(EquipmentStatusCaption);
